import React from 'react';
import { Box, Keyboard, TextInput } from 'grommet';
import { FormClose } from 'grommet-icons';

function escape(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function SearchBar(props) {
  const {
    data, focus, target, setTarget,
  } = props;

  const [searchValue, setSearchValue] = React.useState('');

  const allChurchNames = data.map(church => church.name).sort();

  const regexp = new RegExp(escape(searchValue), 'i');
  const suggestions = (allChurchNames.filter(name => name.match(regexp)));

  function onEnter() {
    if (searchValue) {
      if (suggestions.length === 1) {
        push(suggestions[0]);
      }
    } else {
      const matches = allChurchNames.filter(
        c => c.toLowerCase() === searchValue.toLowerCase(),
      );
      if (matches.length === 1) {
        push(matches[0]);
      }
    }
  }

  function push(value) {
    const selectedChurch = data.find(church => church.name === value);
    console.log(selectedChurch.id);
    setTarget(selectedChurch.id);
  }

  return (
    <Box
      fill="horizontal"
      direction="row"
      align="center"
    >
      <Keyboard
        onEnter={() => { onEnter(); }}
      >
        <TextInput
          placeholder="Search Churches"
          size="medium"
          plain
          dropHeight="medium"
          dropAlign={{
            top: 'bottom',
            right: 'right',
            left: 'left',
          }}
          value={searchValue}
          onChange={event => setSearchValue(event.target.value)}
          onSelect={(event) => {
            setSearchValue(event.suggestion);
            push(event.suggestion);
          }}
          suggestions={suggestions}
          onFocus={() => focus(true)}
          onBlur={() => focus(false)}
        />
      </Keyboard>
      {searchValue.length > 0 && (
        <FormClose
          onClick={() => setSearchValue('')}
        />
      )}
    </Box>
  );
}

export default SearchBar;
